import { useSearchParams } from 'react-router-dom';
import {
  PRICING_CHANNEL_ORDER,
  PricingChannel,
} from '@/services/Pricing/pricing-configuration.service';

export const PRICING_CHANNEL_PARAM = 'channel';

// In-person is the legacy channel, so the default tab matches what this screen showed pre-split.
export const DEFAULT_PRICING_CHANNEL: PricingChannel = 'inPerson';

// Compares values, not `raw in <object>`: `in` walks the prototype chain, so `?channel=toString`
// would pass.
export const parsePricingChannel = (raw: unknown): PricingChannel | null =>
  PRICING_CHANNEL_ORDER.find((channel) => channel === raw) ?? null;

// An absent or unrecognised param falls back to the default without rewriting the URL, so no
// history entry is written on mount.
export function usePricingChannel() {
  const [searchParams, setSearchParams] = useSearchParams();
  const channel = parsePricingChannel(searchParams.get(PRICING_CHANNEL_PARAM)) ?? DEFAULT_PRICING_CHANNEL;

  const setChannel = (next: PricingChannel) => {
    // Copy existing params, or `?tab=` and `?planId=` are dropped on the plan page.
    setSearchParams((previous) => {
      const params = new URLSearchParams(previous);
      params.set(PRICING_CHANNEL_PARAM, next);
      return params;
    });
  };

  return { channel, setChannel };
}
